import React, { useState, useEffect, useRef } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import SubNav from '../../PageComponents/Nav/SubNav'
import CashBoxes from './CashBoxes';
import Banks from './Banks';;
import AddTransactionBanks from './AddTransactionBanks';
import AddTransactionCashBox from './AddTransactionCashBox';
import helper from '../../Services/helper';

const PaymentsMenus = (props) => {
    const links = [
        {path:"payment/cashboxes", name:helper().translate("CASHBOX"), icon:"fas fa-money-check-alt mr-2", component: CashBoxes, type:"menu"},
        {path:"payment/cashbox/:id", name:"Arka", icon:"fas fa-money-bill mr-2", component: AddTransactionCashBox, type:"link"},
        {path:"payment/banks", name:helper().translate("BANK"), icon:"fas fa-money-bill mr-2", component: Banks, type:"menu"},
        {path:"payment/bank/:id", name:"Bank", icon:"fas fa-money-bill mr-2", component: AddTransactionBanks, type:"link"}
        // {path:"payment/bank/0", name:"F | Transaksionet", icon:"fas fa-money-bill mr-2", component: AddTransactionBanks, type:"menu"}
    ]
    return (
        <div className="d-flex">
            <div className="p-0 position-relative sub-menu">
                <SubNav links={links} />
            </div>
            <div className="w-100 overflow-auto overflow-auto pr-0">
                {props.location.pathname === '/administration' && <AddUser />}
                <Router>
                    <Switch>
                        {links.map((link , key)=>{
                            return <Route key={key} path={`/${link.path}`} component={link.component} />
                        })}
                    </Switch>
                </Router>
            </div>
        </div>
    )
}

export default PaymentsMenus
